<template>
  <div>
    <form-wrapper :validator="$v.data">
      <div>
        <fieldset :disabled="isFormDisabled" class="no-margin">
          <b-row class="form-group">
            <b-col cols="4">
              <div class="label">Address *</div>
            </b-col>
            <b-col cols="8">
              <div class="value">
                <BaseInput
                  v-model="data.address_line1"
                  name="address1"
                  class="no-margin"
                />
              </div>
            </b-col>
          </b-row>

          <b-row class="form-group">
            <b-col cols="4">
              <!-- <div class="label">Address 3</div> -->
            </b-col>
            <b-col cols="8">
              <div class="value">
                <BaseInput
                  v-model="data.address_line2"
                  name="address1"
                  class="no-margin"
                />
              </div>
            </b-col>
          </b-row>

          <b-row class="form-group">
            <b-col cols="4">
              <div class="label">City *</div>
            </b-col>
            <b-col cols="8">
              <BaseInput
                v-model="data.city"
                name="address1"
                class="no-margin"
              />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col cols="4">
              <div class="label">Postal Code *</div>
            </b-col>
            <b-col cols="8">
              <BaseInput
                type="number"
                v-model="data.postal_code"
                name="address1"
                class="no-margin"
              />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col cols="4">
              <div class="label">Country *</div>
            </b-col>
            <b-col cols="8">
              <DropDown v-model="data.country_id" :options="countries" />
            </b-col>
          </b-row>
        </fieldset>
        <b-row>
          <b-col cols="8" class="offset-md-4">
            <b-button size="sm" @click="save" variant="primary" name="add">
              Save
            </b-button>
            <b-button size="sm" @click="clear" variant="light" name="clear"
              >Clear</b-button
            >
          </b-col>
        </b-row>
      </div>
    </form-wrapper>
  </div>
</template>
<script>
import lodash from "lodash";
import BaseInput from "@/components/base/Input";
import DropDown from "@/components/base/DropDown";
import { mapState, mapGetters } from "vuex";
import { required, numeric } from "vuelidate/lib/validators";
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
import integer from "vuelidate/lib/validators/integer";

export default {
  components: {
    BaseInput,
    DropDown,
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    showAddressType: {
      type: Boolean,
      default: false,
    },
    allowToChangeAddressType: {
      type: Boolean,
      default: true,
    },
    primaryAddress: {
      type: Boolean,
      default: true,
    },
    actionName: {
      type: String,
      default: "Add Address",
    },
    isFormDisabled: {
      type: Boolean,
      default: false,
    },
    countryEditable: {
      type: Boolean,
      default: false,
    },
    excludeBrunei: {
      type: Boolean,
      default: false,
    },
    isStakeHolderForeign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorMessages: [],
      countries: [
        { id: "1", name: "Srilanka" },
        { id: "2", name: "UK" },
        { id: "3", name: "USA" },
      ],
    };
  },
  computed: {
    // ...mapGetters("", [
    //   "getCountries"
    // ]),
    // ...mapGetters("application", ["getBusinessNameTypeId", "getAddresses"])
  },
  validations: {
    data: {
      address_line1: { required },
      address_line2: {},
      city: { required },
      postal_code: { required, numeric },
      country_id: { required, numeric },
    },
  },
  methods: {
    AddAnotherAddress() {},
    fetchDetails(selection) {},
    save() {
      if (this.isValid()) {
        this.$v.$reset();
        this.$emit("saveAddress", this.data);
      }
    },
    clear() {
      this.$emit("clearAddress");
      this.$v.$reset();
    },
    clearValidations() {
      this.$v.$reset();
    },

    isValid() {
      this.$v.$touch(); // it will validate all fields
      let status = !this.$v.$invalid;
      this.$emit("valid", status);
      if (this.$v.$invalid) return false;

      // if (
      //   this.getAddresses.filter(
      //     a => a.requestOperationType != RequestOperationType.CEASE
      //   ).length >= 20
      // ) {
      //   this.errorMessages.push({
      //     id: 11,
      //     message: 'Maximum twenty Addresses allowed to enter'
      //   })
      //   return false
      // }

      return true;
    },
  },
};
</script>

<style>
.form-group.no-margin {
  margin-bottom: 0;
}
</style>
